/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "agenda": {
        "nested": {
          "ActionPayload": {
            "fields": {
              "service": {
                "type": "string",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": "squareup.agenda.PushNotificationActions"
                }
              },
              "method": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "request": {
                "type": "bytes",
                "id": 3,
                "rule": "optional"
              },
              "buttonTitle": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "type": {
                "type": ".squareup.agenda.ActionPayload.Type",
                "id": 5,
                "rule": "optional",
                "options": {
                  "default": "NORMAL"
                }
              },
              "resultTitle": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "NORMAL": 1,
                  "DESTRUCTIVE": 2
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.agenda?.nested?.ActionPayload && !$root.nested?.squareup?.nested?.agenda?.nested?.ActionPayload?.nested?.Type) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ActionPayload @ squareup/agenda/notifications.proto at 216:1
 */
export const ActionPayload = $root.lookupType('squareup.agenda.ActionPayload');
fixType(ActionPayload, {
  method: {
    notEmpty: true
  },
  request: {
    required: true
  }
});
Builder.createAndAttachToType(ActionPayload);
/**
 * SOURCE Type @ squareup/agenda/notifications.proto at 217:3
 */
ActionPayload.Type = $root.lookupEnum('squareup.agenda.ActionPayload.Type').values;